import { useScrollReveal } from "@/hooks/useScrollReveal";

const services = [
  {
    icon: "ri-flight-takeoff-line",
    title: "Transfer Aeroporto",
    desc: "Recepção e traslado para todos os aeroportos com pontualidade garantida. Monitoramos seu voo em tempo real.",
    highlight: "Disponível 24h",
  },
  {
    icon: "ri-building-2-line",
    title: "Executivo Corporativo",
    desc: "Transporte para reuniões, eventos e compromissos empresariais com discrição e profissionalismo.",
    highlight: "Frota Premium",
  },
  {
    icon: "ri-map-pin-2-line",
    title: "Turismo & City Tour",
    desc: "Explore a cidade com conforto e estilo. Roteiros personalizados com motorista particular.",
    highlight: "Personalizado",
  },
  {
    icon: "ri-heart-line",
    title: "Eventos Especiais",
    desc: "Casamentos, formaturas e celebrações merecem um transporte à altura. Chegue com elegância.",
    highlight: "Momentos Únicos",
  },
  {
    icon: "ri-user-star-line",
    title: "Motorista Particular",
    desc: "Contrate um motorista dedicado por hora ou dia. Flexibilidade total para sua agenda.",
    highlight: "Sob Demanda",
  },
  {
    icon: "ri-global-line",
    title: "Viagens Interestaduais",
    desc: "Viagens longas com máximo conforto. Veículos preparados para longas distâncias.",
    highlight: "Todo o Brasil",
  },
];

interface ServiceCardProps {
  service: { icon: string; title: string; desc: string; highlight: string };
  idx: number;
}

function ServiceCard({ service, idx }: ServiceCardProps) {
  const card = useScrollReveal({ threshold: 0.1, rootMargin: "0px 0px -40px 0px" });
  return (
    <div
      ref={card.ref}
      style={{ transitionDelay: `${idx * 80}ms` }}
      className={`group relative bg-zinc-900 border border-zinc-800 hover:border-slate-500/60 rounded-lg p-8 transition-all duration-500 overflow-hidden cursor-pointer ${
        card.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"
      }`}
    >
      {/* Silver accent top */}
      <div className="absolute top-0 left-0 w-0 group-hover:w-full h-0.5 bg-gradient-to-r from-slate-400 to-slate-200 transition-all duration-500"></div>

      {/* Highlight badge */}
      <span className="inline-block text-xs font-semibold text-slate-300 bg-slate-400/10 border border-slate-400/30 px-3 py-1 rounded-full mb-5">
        {service.highlight}
      </span>

      {/* Icon */}
      <div className="w-14 h-14 flex items-center justify-center bg-slate-400/10 rounded-lg mb-5 group-hover:bg-slate-400/20 transition-all duration-300">
        <i className={`${service.icon} text-slate-300 text-2xl`}></i>
      </div>

      <h3 className="text-white font-bold text-xl mb-3">{service.title}</h3>
      <p className="text-gray-400 text-sm leading-relaxed">{service.desc}</p>


    </div>
  );
}

export default function ServicesSection() {
  const header = useScrollReveal({ threshold: 0.1 });

  return (
    <section id="services" className="bg-black py-24 px-6">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div
          ref={header.ref}
          className={`text-center mb-16 transition-all duration-700 ${
            header.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"
          }`}
        >
          <div className="flex items-center justify-center gap-3 mb-4">
            <div className="h-px w-12 bg-slate-400"></div>
            <span className="text-slate-300 text-sm font-semibold tracking-widest uppercase">
              O Que Oferecemos
            </span>
            <div className="h-px w-12 bg-slate-400"></div>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Nossos <span className="text-slate-300">Serviços</span>
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            Soluções completas de transporte executivo para cada necessidade, com excelência e sofisticação.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, idx) => (
            <ServiceCard key={idx} service={service} idx={idx} />
          ))}
        </div>
      </div>
    </section>
  );
}
